import {meetingRoomAdapter} from './adapters';
import {RoomsState} from './types';

export const getInitialState = (): RoomsState => ({
  meetingRooms: meetingRoomAdapter.getInitialState(),
  capacityFilteredAvailableMeetingRoomIds: [],
  capacityFilteredAvailableMeetingRoomsLoadingStatus: 'NotLoaded',
  availableMeetingRoomIds: [],
  availableMeetingRoomLoadingStatus: 'NotLoaded',
  meetingRoomSuggestionsByBuilding: {},
  buildingMeetingRoomAmenities: {
    status: 'NotLoaded',
    meetingRoomAmenitiesByBuilding: {},
  },
});
